import { ERequestMethod } from '../../app.enums';
import { ApiUpdateRequest } from './api-update.request';

export class ApiPatchRequest extends ApiUpdateRequest {
    public apiMethod = ERequestMethod.PATCH;
}
